import type { JSX } from 'react';

import { Link } from '@/i18n/navigation';

interface HelpCategoryCardProps {
	code: string;
	title: string;
	countLabel: string;
	articles: { slug: string; title: string }[];
}

export function HelpCategoryCard({
	code,
	title,
	countLabel,
	articles,
}: HelpCategoryCardProps): JSX.Element {
	return (
		<div className="border-border bg-surface flex flex-col border p-5 sm:p-6">
			<div className="flex items-center gap-3.5">
				<span className="border-fg flex size-10 shrink-0 items-center justify-center border font-mono text-xs font-bold tracking-wide">
					{code}
				</span>
				<span className="flex min-w-0 flex-col gap-0.5">
					<span className="truncate text-base font-medium tracking-tight sm:text-lg">
						{title}
					</span>
					<span className="label-mono">{countLabel}</span>
				</span>
			</div>
			<div className="border-border-subtle mt-4 border-t" />
			<ul className="flex flex-col">
				{articles.map((a) => (
					<li key={a.slug}>
						<Link
							href={`/help/${a.slug}`}
							className="group/link border-border-subtle text-accent hover:text-fg focus-visible:ring-fg flex items-center justify-between gap-3 border-b py-3.5 text-sm leading-snug no-underline transition-[color,padding] last:border-b-0 hover:ps-1.5 focus-visible:ring-1 focus-visible:outline-none"
						>
							<span>{a.title}</span>
							<span
								className="text-muted shrink-0 font-mono text-xs transition-transform group-hover/link:translate-x-0.5"
								aria-hidden="true"
							>
								→
							</span>
						</Link>
					</li>
				))}
			</ul>
		</div>
	);
}
